import { ImageIcon, ViewVerticalIcon } from '@radix-ui/react-icons'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { SubmenuComponent } from 'features/kestrelViewer/ui/tools/SubmenuComponent'
import React from 'react'

import { DockPhotoReelButton } from './DockPhotoReelButton'

export const PhotoReel: React.FC = () => {
  const { kestrelModel } = useKestrel()
  const { trackButtonClicked } = useGeckoAnalytics()
  const {
    setHelperTextVisible,
    photoReelOpen,
    setPhotoReelOpen,
    photoReelDocked,
    setPhotoReelDocked,
    photoReelMode,
    setSelectedPhoto,
  } = useKestrelViewerContext()

  const handleToggle = () => {
    if (photoReelMode === 'docked') {
      if (photoReelDocked) {
        setPhotoReelDocked(false)
        setSelectedPhoto(null)
      } else {
        setPhotoReelDocked(true)
      }
      return
    }

    if (photoReelOpen) {
      setPhotoReelOpen(false)
      return
    }

    setPhotoReelOpen(true)
    setHelperTextVisible(false)
    trackButtonClicked({
      button_name: 'kestrel_photo_reel',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  if (!kestrelModel?.id || !kestrelModel?.data.photosEnabled) {
    return null
  }

  const isOpen = photoReelMode === 'docked' ? photoReelDocked : photoReelOpen

  const mainIcon =
    photoReelMode === 'docked' ? (
      <ViewVerticalIcon width={22} height={22} color='white' />
    ) : (
      <ImageIcon width={22} height={22} color='white' />
    )

  return (
    <SubmenuComponent
      label='Photo Reel'
      icon={mainIcon}
      handleClick={handleToggle}
      selected={isOpen}>
      <DockPhotoReelButton />
    </SubmenuComponent>
  )
}
